import * as Excel from 'exceljs';
import {saveAs} from 'file-saver';

export default function teacherPackets(rows) {
    if (!rows) return;
    const fileDate = new Date();
    let workbook = new Excel.Workbook();
    workbook.creator = 'Accounting Data Solutions';
    workbook.lastModifiedBy = 'nGauge Mock Exam Scoring Service';
    workbook.created = new Date(2019, 6, 16);
    workbook.modified = fileDate;
    // workbook.lastPrinted = fileDate;
    workbook.properties.date1904 = true;
    workbook.views = [{x: 0, y: 0, firstSheet: 0, activeTab: 1, visibility: 'visible'}];

    let sheet = workbook.addWorksheet('Detail by Teacher', {
        views: [{xSplit: 0, ySplit: 1}],
    });
    sheet.autoFilter = 'A1:G1';
    sheet.columns = [
        {header: 'State', key: 'state', width: 20},
        {header: 'School', key: 'school', width: 20},
        {header: 'Exam', key: 'exam', width: 50},
        {header: 'Teacher', key: 'teacher', width: 20},
        {header: 'Ordered', key: 'ordered', width: 13},
        {header: 'Scanned', key: 'scanned', width: 13},
        {header: 'Unevaluated Responses', key: 'unevaluated_responses', width: 13},
    ];

    sheet.addRows(rows);
    const fileDateString = fileDate.toLocaleDateString(); // .replace('/', '-');

    workbook.xlsx.writeBuffer().then(buffer => {
        saveAs(
            new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
            'Detail by Teacher as of ' + fileDateString + '.xlsx'
        );
    });
}
